import { SLOTS } from './slots.js'

// Boost templates: ranked, drag-reorderable point multipliers. Primary links to edit.
export default {
  key: 'boost',
  label: 'Boost',
  icon: 'boosts',
  columns: [
    { slot: SLOTS.PRIMARY, field: 'name', link: 'url' },
    { slot: SLOTS.CONTEXT, field: 'area.name', label: 'College Town', areaScoped: true, link: 'area.url' },
    { slot: SLOTS.STATUS, field: 'active', label: 'Active', renderer: 'toggle' },
    // Rank = row order in the shown list (old CMS List*Row printed index + 1)
    { slot: SLOTS.METADATA, field: 'rank', label: 'Rank', renderer: 'points', align: 'right' },
    {
      slot: SLOTS.METADATA,
      field: 'type_tags',
      label: 'Type',
      renderer: 'tags',
      badges: {
        Super: { label: 'Super', badgeClass: 'badge-warning' },
        Members: { label: 'Members', badgeClass: 'badge-secondary' },
        Standard: { label: 'Standard', badgeClass: 'badge-outline' }
      }
    },
    { slot: SLOTS.METADATA, field: 'display_name', label: 'Display Name' },
    { slot: SLOTS.METADATA, field: 'multiplier_label', label: 'Multiplier', align: 'right' },
    { slot: SLOTS.METADATA, field: 'schedule', label: 'Schedule', renderer: 'schedule' }
  ],
  empty: { icon: 'boosts', message: 'No boost templates found.' },
  defaultView: 'table',
  compact: { show: [SLOTS.PRIMARY, SLOTS.STATUS] }
}
